var utils = require('../../utils')
import AppHeader from '../AppHeader'

export default {
  name: 'stepup-result-list',
  created () {
    this.search(false)
    // 最下部スクロール検索イベント
    utils.scrollBottomSearchEvent(this.search, true, 'button.next-page-search-btn')
  },
  data () {
    return {
      stepups: '',
      searchShop: '',
      searchUser: '',
      searchEnd: false,
      nextExist: false,
      currentPage: 0
    }
  },
  /** 画面遷移時 */
  beforeRouteLeave (to, from, next) {
    utils.scrollBottomSearchEventRemove() // 最下部スクロール検索イベント削除
    next()
  },
  computed: {
  },
  components: {
    AppHeader
  },
  methods: {
    async search (addSearch) {
      let data = {
        search_shop: this.searchShop,
        search_user: this.searchUser,
        for_result: true
      }
      if (addSearch) {
        this.currentPage += 1
        data['current_page'] = this.currentPage
        data['add_search'] = true
      } else {
        this.searchEnd = false
        this.currentPage = 0
      }

      let res = await this.$store.dispatch('GET_STEPUP_LIST', { data: data })
      .catch(err => {
        console.log(err)
        return
      })

      if (addSearch) {
        this.stepups = this.stepups.concat(res.step_ups.data)
      } else {
        this.stepups = res.step_ups.data
        this.searchEnd = true
      }
      this.nextExist = res.next_exist
    },
    async goDataDownload (stepupEntryId) {
      let data = {
        step_up_entry_id: stepupEntryId
      }
      let res = await this.$store.dispatch('CSV_STEPUP_ANSWER', { data: data })
      .catch(err => {
        console.log(err)
        return
      })
      this.onDownloadCsv(res.res_csv_data, res.max_question_size)
    },
    onDownloadCsv: function (data, maxSize) {
      const csvFileName = 'stepup.csv'
      let bom = new Uint8Array([0xef, 0xbb, 0xbf])
      let mimeType = 'text/csv'
      let csv = '店舗名,ステップアップ者役職,ステップアップ者名,評価者役職,評価者名,回答状態,'
      for (let i = 1; i <= maxSize; i++) {
        csv += '評価項目' + i + ','
        if (i === maxSize) {
          csv += '回答' + i + '\n'
        } else {
          csv += '回答' + i + ','
        }
      }
      data.forEach(obj => {
        if (obj.shop_name) {
          csv += this.enquoteForCSV(obj.shop_name) + ','
        } else {
          csv += ','
        }
        if (obj.step_up_user_type) {
          csv += this.enquoteForCSV(obj.step_up_user_type) + ','
        } else {
          csv += ','
        }
        if (obj.step_up_user_name) {
          csv += this.enquoteForCSV(obj.step_up_user_name) + ','
        } else {
          csv += ','
        }
        if (obj.user_user_type) {
          csv += this.enquoteForCSV(obj.user_user_type) + ','
        } else {
          csv += ','
        }
        if (obj.user_name) {
          csv += this.enquoteForCSV(obj.user_name) + ','
        } else {
          csv += ','
        }
        if (obj.is_all_answered) {
          csv += this.enquoteForCSV(obj.is_all_answered) + ','
        } else {
          csv += '0,'
        }
        let existFlag = null
        let nextExistFlag = null
        let wkIndex = 0
        let beforeEnquote = ''
        for (let i = 0; i < 99999; i++) {
          eval('existFlag = obj.answer_content' + i)
          if (typeof existFlag === 'undefined') {
            break
          } else {
            eval('beforeEnquote = obj.question_content' + i)
            csv += this.enquoteForCSV(beforeEnquote) + ','
            eval('csv += obj.answer_content' + i)
            wkIndex = i + 1
            eval('nextExistFlag = obj.answer_content' + wkIndex)
            if (typeof nextExistFlag === 'undefined') {
              csv += '\n'
            } else {
              csv += ','
            }
          }
        }
      })
      const blob = new Blob([bom, csv], { type: mimeType })
      let hiddenElement = document.createElement('a')
      hiddenElement.download = csvFileName
      hiddenElement.target = '_blank'
      if (window.navigator.msSaveBlob) {
        window.navigator.msSaveBlob(blob, csvFileName)
      } else if (window.URL && window.URL.createObjectURL){
        hiddenElement.href = window.URL.createObjectURL(blob)
        document.body.appendChild(hiddenElement)
        hiddenElement.click()
        document.body.removeChild(hiddenElement)
      } else if (window.webkitURL && window.webkitURL.createObject) {
        hiddenElement.href = (window.URL || window.webkitURL).createObjectURL(blob)
        hiddenElement.click()
      }
    },
    enquoteForCSV: function (val) {
      if (!val) return val
      if (/[",\r\n]/.test(val)) { //",\r\nが含まれる場合はenquoteする
        val = '"' + val.replace(/"/g, '""') + '"'
      }
      return val
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/stepup-result-list.js